/* eslint-disable react/jsx-no-bind */
/* eslint-disable consistent-return */
import {
  DefaultButton,
  SearchBarComponent,
  Toggle,
  Loading,
  ButtonCopy,
  HeaderPage,
  NewModal,
  FilterMulti,
  SelectedSpecialists,
  Filter2,
  Kanban2,
  SearchMenu,
} from 'components/index'
import axios from 'axios'
import { Icon } from 'assets/index'
import { useContext, useEffect, useState } from 'react'
import { UserContext, GeneralContext } from 'context'
import { IObject } from 'interfaces'
import { PageScrollContent } from 'styles/index'
import { clearString, optionsLevels, hasAccess } from 'helper/utils'
// import NovaConta from './NovaConta'
import { useFetch, useStorage } from '../../hooks'
import * as modals from './Modal'
import { Container } from './style'
import DeleteProposta from './DeleteProposta'

export default function Clientes() {
  const {
    showModal,
    setShowModal,
    setData,
    selectedId,
    toggleCap,
    checkbox,
    page,
    setPage,
    setToggleCap,
    setCheckbox,
    setClientOption,
  } = useContext(UserContext)
  const general: any = useContext(GeneralContext)

  // RENDERIZACAO DE MODAL
  const [localModal, setLocalModal] = useState(false)
  const [modalData, setModalData] = useState<any>([])

  // DADOS PARA RENDEIZAR O KANBAN
  const [kanbanOriginalData, setKanbanOriginalData] = useState<any[]>([])
  const [kanbanData, setKanbanData] = useState<any[]>([])

  // FILTROS DE BUSCA PREENCHIDOS
  const [documentCliente, setDocumentoCliente] = useState('')
  const [especialistaFiltro, setEspecialistaFiltro] = useState<any>([])
  const [selectedGestor, setSelectedGestor] = useState<any>(null)
  const [gestors] = useStorage('Gestores')
  const [gestSpecialist] = useStorage('GestSpec')
  const [especialists] = useStorage('Especialistas')

  const [toggle, setToggle] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [pallete] = useStorage('pallete')

  // COLABORADORES
  const [user] = useStorage('User')
  const [colaboradores] = useStorage('Colaboradores')
  const filteredEspecialistOptionsInitial = [...gestSpecialist, ...especialists]
  const [filteredEspecialistOptions, setFilteredEspecialistOptions] = useState(
    filteredEspecialistOptionsInitial
  )

  const [searchMenuIsExpanded, setSearchMenuIsExpanded] = useState(false)
  // abrir e fechar o menu de busca

  const kanbanApi = useFetch()

  const formatKanban = ({ kanban, collaboratorMap }: any) => {
    return kanban.forEach((pipeline: any) => {
      pipeline.cardList.forEach((card: any) => {
        const specialist: any = collaboratorMap.get(card.specialistId)
        card.specialist = specialist
          ? {
              id: specialist.id,
              name: specialist.name,
              profilePicture: specialist.profilePic,
            }
          : general.gestor.default

        card.tags = card.tagList
          ? card.tagList.map((item: IObject) => ({
              ...item,
              background: pallete[item.background || 'BLACK'],
              color: pallete[item.color || 'WHITE'],
            }))
          : [
              { value: card.status, color: '#FFFFFF', background: '#00CD52' },
              { value: card.type, color: '#1C1D22', background: '#FFFFFF' },
            ]

        card?.customData?.analyzeFields &&
          card.tags.push({
            value: 'Analisar',
            background: '#FFC600',
            color: '#FFFFFF',
          })
        card?.customData?.analyzePicture &&
          card.tags.push({
            value: 'Analisar fotos',
            background: '#e81616',
            color: '#FFFFFF',
          })
      })
    })
  }

  async function fetch(target: string) {
    setLoading(true)
    kanbanApi
      .fetch('get', null, `/gestor/kanban/${target}`)
      .then(async (response) => {
        const kanban = response.data.data
        // Create a map for quick lookups
        const collaboratorMap = new Map(
          colaboradores.map((item: any) => [item.id, item])
        )

        formatKanban({ kanban, collaboratorMap })

        setKanbanData(kanban)

        setKanbanOriginalData(kanban)
        // setKanbanCliente(kanban)
        // setLoading(false)
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.error('Fetch aborted')
        } else {
          console.error('Fetch error:', err)
        }
        setLoading(false)
      })
      .finally(() => setLoading(false))
  }
  const formatName = (str: any) => {
    if (!str) return ''
    return str
      .toLowerCase() // Converte para minúsculas
      .normalize('NFD') // Normaliza a string para a forma de decomposição canônica NFD
      .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
      .replace(/[^a-z0-9\s]/g, '') // Remove caracteres não alfanuméricos, exceto espaços
      .trim() // Remove espaços no início e no fim
  }

  useEffect(() => {
    // *************************************************************
    // SETAR QUAL O TIPO DE MODAL DE CADASTRO DE PROPOSTA DEVE ABRIR
    // QUANDO CLICAR EM NOVA PROPOSTA
    // *************************************************************
    if (typeof toggleCap !== 'string') return
    switch (toggleCap) {
      case 'Investimento realizado':
        return setModalData(modals.baseCaptacao)
      case 'Proposta personalizada':
        setModalData(checkbox ? modals.baseCaptacao : modals.novaCaptacao)
        return
      case 'Captação aberta':
        return setModalData(modals.novaCaptacao)
      default:
    }

    return () => {
      setModalData(modals.novaCaptacao)
    }
  }, [toggleCap, checkbox])

  useEffect(() => {
    // *************************************************************
    // RESTRINGIR ACESSO DO TIPO JURIDICO
    // *************************************************************
    if (optionsLevels[user.level] === 'LEGAL') {
      setToggle('contract')
    }
  }, [])

  useEffect(() => {
    // *************************************************************
    // FILTRAR DADOS DO KANBAN
    // *************************************************************
    const filters: ((card: any) => boolean)[] = [] // Lista de funções de filtro

    function isNumber(value: string): boolean {
      // Remove espaços e caracteres especiais como parênteses, hífens, etc.
      value = value.trim().replace(/[.,()-\s]/g, '')

      // Verifica se o valor restante é puramente numérico
      const validPattern = /^[0-9]+$/
      return validPattern.test(value)
    }

    const applyFilters = (data: any[]) => {
      return data.map((column: any) => ({
        ...column,
        cardList: column.cardList.filter((card: any) =>
          filters.every((filter) => filter(card))
        ),
      }))
    } // Aplica todos os filtros

    if (documentCliente) {
      filters.push((card: any) => {
        const filterLetters = formatName(card?.name).includes(
          formatName(documentCliente)
        )

        const filterNumbers =
          String(clearString(card?.document)).includes(
            clearString(documentCliente)
          ) ||
          String(clearString(card?.cellphone)).includes(
            clearString(documentCliente)
          )
        return isNumber(documentCliente) ? filterNumbers : filterLetters
        // Se for número, filtra por número, senão filtra por nome
      })
    }

    if (especialistaFiltro?.length) {
      const specialistIds = especialistaFiltro.map(
        (item: { value: any }) => item.value
      )
      filters.push((card: any) => specialistIds.includes(card.specialistId))
    } // Adiciona filtro de especialistas se houver

    if (selectedGestor?.value) {
      filters.push(
        (card: any) =>
          card?.superior?.id === selectedGestor.value ||
          card?.specialistId === selectedGestor.value
      ) // Adiciona filtro de gestor
    }

    const filteredData = applyFilters(kanbanOriginalData)

    setKanbanData(filteredData)
  }, [documentCliente, especialistaFiltro, kanbanOriginalData, selectedGestor])

  useEffect(() => {
    if (selectedGestor?.value) {
      const filtered = filteredEspecialistOptionsInitial.filter(
        (especialist: { superior: { id: any }; id: any }) =>
          especialist.superior?.id === selectedGestor.value ||
          especialist.id === selectedGestor.value
      )
      setEspecialistaFiltro([])
      setFilteredEspecialistOptions(filtered)
    } else {
      setFilteredEspecialistOptions(filteredEspecialistOptionsInitial)
    }
  }, [selectedGestor])
  // Filtra os especialistas de acordo com o gestor selecionado

  const kanbanModal = async () => {
    // let specialistList = general.gestor.get()
    if (typeof toggle !== 'string') return
    switch (toggle) {
      case 'account':
        setModalData(modals.account)
        return fetch('account')
      case 'comercial':
        setModalData(modals.gestor)
        return fetch('comercial')
      case 'contract':
        setModalData(modals.legal)
        return fetch('contract')
      case 'captations':
        setModalData(modals.contract)
        return fetch('deadline_contract')
      case 'withdraw':
        setModalData(modals.account)
        return fetch('withdraw')
      default:
    }
  }

  useEffect(() => {
    // *************************************************************
    // RESETAR O DATA QUANDO FECHAR O MODAL
    // ATUALIZAR OS DADOS DO KANBAN
    // *************************************************************
    if (localModal) return
    if (showModal) return
    kanbanModal()
    if (!showModal) return setData({})
  }, [showModal, toggle, localModal])

  // const filterByContractType = (e: any) => {
  // console.log(e)
  // const arr = kanbanOriginalData.map((column: any) => {
  //   return {
  //     ...column,
  //     cardList: column?.cardList.filter((card: any) => {
  //       const filter = Number.isNaN(Number(document))
  //       return filter
  //         ? formatName(card?.name).includes(formatName(document))
  //         : String(card?.document).includes(clearString(document)) // Verifica o nome
  //     }),
  //   }
  // })
  // setKanbanData(arr)
  // }
  let isProcessing = false
  function onMoveCard(card: IObject, status: string) {
    if (isProcessing) return
    isProcessing = true

    if (!toggle) return

    // Função para mover o card
    status = String(status)
    return kanbanApi
      .fetch('put', { status }, `/gestor/kanban/${toggle}/${card.id}`)
      .then((r: IObject) => {
        if (r.fail) fetch(toggle)
        let target = toggle
        if (toggle === 'captations') target = 'deadline_contract'
        kanbanApi
          .fetch('get', null, `/gestor/kanban/${target}`)
          .then(async (response) => {
            const kanban = response.data.data

            // Create a map for quick lookups
            const collaboratorMap = new Map(
              colaboradores.map((item: any) => [item.id, item])
            )

            formatKanban({ kanban, collaboratorMap })
            setKanbanOriginalData(kanban)
          })
          .catch((err) => {
            if (axios.isCancel(err)) {
              console.error('Fetch aborted')
            } else {
              console.error('Fetch error:', err)
            }
            setLoading(false)
          })
          .finally(() => {
            isProcessing = false
          })
      })
  }

  const handleDelete = (id: string) => {
    selectedId.current = id
    setLocalModal(true)
  }

  const isDeletable = toggle === 'comercial' || toggle === 'contract'

  function getHeaderText(toggleTxt: string): string {
    const headers: Record<string, string> = {
      account: 'Gestão de clientes',
      comercial: 'Gestão de clientes > Fluxo comercial',
      contract: 'Gestão de clientes > Fluxo jurídico',
      captations: 'Gestão de clientes > Fluxo de contratos',
      withdraw: 'Gestão de clientes > Saques',
    }

    return headers[toggleTxt] || toggleTxt
  }

  return (
    <Container isExpanded={searchMenuIsExpanded}>
      <PageScrollContent flexDirection="row">
        <SearchMenu
          setIsExpanded={setSearchMenuIsExpanded}
          isExpanded={searchMenuIsExpanded}
        >
          <div className="clientes-container-left">
            <DefaultButton
              onClick={() => {
                setPage(0)
                setModalData(modals.newAccount)
                setShowModal(true)
              }}
              id="new-client-button"
              small
              icon={Icon('plus.svg')}
              disabled={!hasAccess('new-client-button')}
            >
              Cadastrar Cliente
            </DefaultButton>

            {/* <ButtonCopy url="https://cadastro.wsbtech.co/" /> */}
            <SearchBarComponent
              width="small"
              dataTestId="search-name-tel-document"
              placeholder={'CPF/CNPJ, Nome ou Tel.'}
              onChange={(e: any) => {
                setDocumentoCliente(e.target.value)
              }}
            />
            {hasAccess('filter-specialist') && (
              <Filter2
                icon={Icon('filter.svg')}
                options={[
                  ...[...gestors, ...gestSpecialist].map((item: any) => ({
                    label: item.name,
                    value: item.id,
                    profilePic: item.profilePic,
                  })),
                ]}
                isClearable
                placeholder="Gestores"
                selected={selectedGestor}
                setSelected={setSelectedGestor}
                dataTestId="filter-gestor"
              />
            )}
            {hasAccess('filter-multi-specialist') && (
              <FilterMulti
                dataTestId="filter-specialist"
                key={JSON.stringify(filteredEspecialistOptions)}
                icon={Icon('trophy.svg')}
                placeholder="Especialista"
                options={[
                  ...filteredEspecialistOptions.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                    profilePic: item.profilePic,
                    superiorId: item?.superior?.id,
                  })),
                ]}
                setSelected={setEspecialistaFiltro}
                selected={especialistaFiltro}
              />
            )}

            {especialistaFiltro && especialistaFiltro.length > 0 && (
              <SelectedSpecialists
                especialistaFiltro={especialistaFiltro}
                setEspecialistaFiltro={setEspecialistaFiltro}
              />
            )}

            {toggle === 'comercial' && (
              <DefaultButton
                icon={Icon('plus.svg')}
                tertiary
                small
                id="new-captation-button"
                disabled={!hasAccess('new-captation-button')}
                onClick={() => {
                  setPage(0)

                  if (
                    optionsLevels[user.level] === 'SPECIALIST' ||
                    optionsLevels[user.level] === 'SPECGESTOR' ||
                    optionsLevels[user.level] === 'GESTOR'
                  ) {
                    setToggleCap('Proposta personalizada')
                    setCheckbox(true)
                    setModalData(modals.baseCaptacao)
                    return setShowModal(true)
                  }
                  setToggleCap('Proposta base')
                  setModalData(modals.novaCaptacao)
                  return setShowModal(true)
                }}
              >
                Nova proposta
              </DefaultButton>
            )}
          </div>
        </SearchMenu>
        <div className="clientes-container-right">
          <HeaderPage path={getHeaderText(toggle)} />
          <div className="clientes-toggle-container">
            <Toggle
              options={
                !loading ? modals.toggleOptionList() : modals.toggleDisabled
              }
              toggle={toggle}
              setToggle={setToggle}
            />
          </div>
          {kanbanData && kanbanData.length > 0 && !loading ? (
            <div className="container-kanban">
              <Kanban2
                onTrash={handleDelete}
                columnsWithTrash={isDeletable ? [0, 1, 2, 3, 4, 5, -8, 6] : []}
                height="100%"
                investCard={toggle === 'captations'}
                data={kanbanData}
                setData={setKanbanData}
                handleClick={(cur: IObject) => {
                  setPage(0)
                  selectedId.current = cur.id
                  kanbanModal()
                  setShowModal(true)
                }}
                onDropCard={onMoveCard}
              />
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                width: '100%',
              }}
            >
              <Loading modal />
            </div>
          )}
        </div>
      </PageScrollContent>
      <NewModal
        showModal={showModal}
        setShowModal={setShowModal}
        backButton
        onBack={
          toggle === 'account' ? () => setClientOption('home') : undefined
        }
      >
        {/* {modalData[page]} */}
        {modalData}
      </NewModal>
      <NewModal
        showModal={localModal}
        height="45%"
        width="60%"
        setShowModal={setLocalModal}
        noCloseButton
        padding={'30px'}
      >
        {[
          [
            <DeleteProposta
              onCancel={() => setLocalModal(false)}
              id={selectedId.current}
            />,
          ],
        ]}
      </NewModal>
    </Container>
  )
}
